import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useSwUpdateStore } from '@store/sw-update-store';

export function useServiceWorkerUpdate() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    const { setUpdateAvailable, setUpdateSW } = useSwUpdateStore.getState();
    setUpdateAvailable(needRefresh);
    if (needRefresh) {
      setUpdateSW(() => updateServiceWorker(true));
    } else {
      setUpdateSW(null);
    }
  }, [needRefresh, updateServiceWorker]);
}
